import React, {useState, useEffect} from 'react'
import Link from 'gatsby-link'
import Signup from '../components/signup'
import heroImage from '../assets/financial_analysis.png'
import fiaIcon from '../assets/fia_icon_large.png'


const IndexPage = () => {

  function useWindowSize() {

    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });

    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
         width: window.innerWidth,
         height: window.innerHeight,
        });
      }

      // Add event listener
      window.addEventListener("resize", handleResize);

      // Call handler right away so state gets updated with initial window size
      handleResize();

      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);

    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
  }

  const size = useWindowSize()

  return (
    <div>
      {
        size.width >= 960 ? (
          <div style={{width: "960px"}} className="container">
            <div className="columns">
              <div className="column col-6">
                <div className="hero">
                  <div>
                    <div style={{height: "32px"}} />
                    <h2 style={{color: "#444643"}}>Fia Finance was built to help couples manage the complexities of their finances.</h2>
                    <div style={{height: "16px"}} />
                    <h4 style={{color: "#444643"}}>Modern relationships rarely look like those of our parents' generation, so why are we still banking as if they do?</h4>
                    <div style={{display: "flex", justifyContent: "center"}}>
                      <Signup />
                    </div>
                    <div style={{height: "32px"}} />
                  </div>
                </div>
              </div>
              <div className="column col-6">
                <div className="hero">
                  <img className="hero-image" src={heroImage} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div style={{width: size.width - 32, margin: "16px"}} className="container">
            <div className="columns">
              <div className="column col-12">
                <div>
                  <div style={{height: "32px"}} />
                  <h2 style={{textAlign: "center", color: "#444643"}}>Fia Finance was built to help couples manage the complexities of their finances.</h2>
                  <div style={{height: "16px"}} />
                  <h4 style={{textAlign: "center", color: "#444643"}}>Modern relationships rarely look like those of our parents' generation, so why are we still banking as if they do?</h4>
                  <div style={{display: "flex", justifyContent: "center"}}>
                    <Signup />
                  </div>
                </div>
                <div style={{display: "flex", justifyContent: "center"}}>
                  <img style={{width: size.width * 0.8, height: size.width * 0.8}} src={heroImage} />
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  )

}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js